import { create } from 'zustand'

interface PropertyProfileState {
  isOpen: boolean
  dealId: string | null
  activeTab: 'property' | 'sponsor' | 'narratives'
  openProfile: (dealId: string) => void
  closeProfile: () => void
  setTab: (tab: 'property' | 'sponsor' | 'narratives') => void
}

export const usePropertyProfileStore = create<PropertyProfileState>((set) => ({
  isOpen: false,
  dealId: null,
  activeTab: 'property',
  openProfile: (dealId) => set({ isOpen: true, dealId, activeTab: 'property' }),
  closeProfile: () => set({ isOpen: false, dealId: null, activeTab: 'property' }),
  setTab: (activeTab) => set({ activeTab }),
}))
